import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-historical-data',
  templateUrl: './historical-data.component.html',
  styleUrls: ['./historical-data.component.css']
})

export class HistoricalDataComponent implements OnInit {
  show: boolean = true;
  selectedTab: string = 'historical-invoices';
  isNewPaymentExperienceEnabled: boolean = environment.newPaymentExperienceEnableFlag;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    if (this.router.url == "/invoices/historical-data/historical-payments") {
      this.selectedTab = 'historical-payments';
    }
    else if (this.router.url == "/invoices/historical-data/historical-invoices") {
      this.selectedTab = 'historical-invoices';
    }
  }

  changeTab(tab: string) {
    if (tab == 'historical-payments')
      this.show = true;
    this.selectedTab = tab;
    this.router.navigate([`${tab}`], { relativeTo: this.route, state: {} });
  }
}